import React from "react";
import { ToastContainer } from "react-toastify";
import Card from "./components/Card.jsx/Card";

function App() {
  return (
    <>
      <Card />
      <ToastContainer />
 
    </>
  );
}

export default App;
